import { Routes } from '@angular/router';
import { authGuard, adminGuard, loginGuard } from './auth/auth.guard';
import { AuthRedirectComponent } from './auth/auth-redirect.component';
import { APP_ROUTE_SEGMENTS } from './app.navigation';
import { environment } from '../environments/environment';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./login/login.component').then(m => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    // This is necessary for handling the redirect from Azure AD
    path: 'auth',
    component: AuthRedirectComponent,
  },
  {
    path: '',
    loadComponent: () => import('./shell/app-shell.component').then(m => m.AppShellComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: APP_ROUTE_SEGMENTS.home,
        pathMatch: 'full',
      },
      {
        path: APP_ROUTE_SEGMENTS.home,
        loadComponent: () => import('./home/home.component').then(m => m.HomeComponent),
      },
      ...(
        environment.featureFlags.showGeoAeoPage
          ? [{
              path: APP_ROUTE_SEGMENTS.geoAeo,
              loadComponent: () => import('./geo-aeo-analysis/geo-aeo-analysis.component').then(m => m.GeoAeoAnalysisComponent),
            }]
          : []
      ),
      ...(
        environment.featureFlags.showAdminConsolePage
          ? [{
              path: APP_ROUTE_SEGMENTS.adminConsole,
              loadComponent: () => import('./admin-console/admin-console.component').then(m => m.AdminConsoleComponent),
              canActivate: [adminGuard],
            }]
          : []
      ),
      ...(
        environment.featureFlags.showUsageMetricsPage
          ? [{
              path: APP_ROUTE_SEGMENTS.usageMetrics,
              loadComponent: () => import('./usage-metrics/usage-metrics.component').then(m => m.UsageMetricsComponent),
              canActivate: [adminGuard],
            }]
          : []
      ),
      {
        path: APP_ROUTE_SEGMENTS.benchmarkUrlAnalysis,
        loadComponent: () => import('./dashboard/benchmark-url-analysis/benchmark-url-analysis.component').then(m => m.BenchmarkUrlAnalysisComponent),
      },
    ],
  },
  {
    path: '**',
    redirectTo: APP_ROUTE_SEGMENTS.home,
  },
];
